import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { IColorMatchingV1, Roles, IxellAPIService, IResponseColorMatchingV1, IIngredientColorMatchingV1, ITextSentenceColorMatchingV1, Reference, ICoatColorMatchingV1 } from 'src/app/tools/api.service';
import { Utils } from 'src/app/tools/utils';
import { HeaderService } from 'src/app/tools/header.service';
import { Router } from '@angular/router';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';
import { STEPPER_GLOBAL_OPTIONS } from '@angular/cdk/stepper';
import { DatePipe } from '@angular/common';
import { ContretypageService, Technologie } from 'src/app/tools/contretypage.service';
import { StorageService } from '../../tools/storage.service';

export enum StatusColorMatchingType {
  PENDING = 1,
  RECEIVED = 2,
  FINISHED = 3
}

export enum Teinte {
  Carrosserie = 1,
  Accessoire = 2,
  Autres = 3
}

@Component({
  selector: 'app-response-color-matching',
  templateUrl: './response-color-matching.component.html',
  styleUrls: ['./response-color-matching.component.scss'],
  providers: [
    { provide: STEPPER_GLOBAL_OPTIONS, useValue: { displayDefaultIndicatorType: false } },
    DatePipe
  ]
})

export class ResponseColorMatchingComponent implements OnInit {

  win: any;
  tabs: string[] = [];
  selected = new UntypedFormControl(0);
  currentTabIndex: number = 0;
  listIngrTabs: IngrTab[] = [];
  StatusColorMatchingType = StatusColorMatchingType;
  Teinte = Teinte;
  Technologie = Technologie;
  recapExpand: boolean;
  respExpand: boolean;
  displayedAXALTA: string[] = ['drag', 'position', 'code', 'name', 'quantity', 'qtyCumule', 'delete'];
  displayedOther: string[] = ['position', 'code', 'name', 'quantity', 'qtyCumule'];
  displayedColumns: string[];
  displayedColumnsIngredient: string[] = ['code', 'name', 'add'];
  manufacturerList: string[];
  formuleList: string[];
  designationList: string[];
  varianteList: string[];
  index: number;
  cumul: number;
  firstDate: Date = new Date('0001-01-01');
  legends: any = [
    { 'id': 1, 'name': '1 - Réparation appropriée avec l’élément donné' },
    { 'id': 2, 'name': '2 - Réparation raccordable dans l’élément donné' },
    { 'id': 3, 'name': '3 - Réparation raccordable dans l’(les) élément(s) adjacent(s)' },
    { 'id': 4, 'name': '4 - Réparation très difficile, risque de peinture complète' }
  ];
  selectedLegend: number;
  techDemande: string;
  paintQuality: number;
  qrcode: string;
  zoomQrcode: string;
  infoQRCode: string;
  timeFinish: string;
  idContretypage: number;
  copyPasteContretypage: number;

  private roleSub: any;
  private manufacturerSub: any;
  private colormatchingSub: any;
  private responseCMSub: any;
  private ingredientCMSub: any;
  private textSentenceCMSub: any;
  private coatCdCMSub: any;
  private formuleSub: any;
  private designationSub: any;
  private varianteSub: any;

  select: any;

  stepEdit: string;

  AllIngredientArray: IIngredientColorMatchingV1[];
  ingredientToAddArray: MatTableDataSource<IIngredientColorMatchingV1>;
  ingredientArray: MatTableDataSource<IIngredientColorMatchingV1>;
  ingr: IIngredientColorMatchingV1[];

  colorMatching: IColorMatchingV1;
  responseCM: IResponseColorMatchingV1;
  responseMulti: IResponseColorMatchingV1;

  lstTextSentencesCM: ITextSentenceColorMatchingV1[];
  textSentencesCM: ITextSentenceColorMatchingV1[];

  lstCoatCdCM: ICoatColorMatchingV1[];
  currentCoatCd: string;
  cloture: boolean;

  Utils = Utils;
  role: Roles = Roles.Unknown;

  responseCMForm = new UntypedFormGroup({
    brandVehicle: new UntypedFormControl('', [Validators.required]),
    codeFormule: new UntypedFormControl('', [Validators.required]),
    designationPainting: new UntypedFormControl('', [Validators.required]),
    variante: new UntypedFormControl('', [Validators.required]),
    legend: new UntypedFormControl('', [Validators.email]),
    comment: new UntypedFormControl(''),
    formuleInfo: new UntypedFormControl(''),
    sentences: new UntypedFormControl(''),
    coatCd: new UntypedFormControl('')
  });

  technologyForm = new UntypedFormGroup({
    technology: new UntypedFormControl('', [Validators.required])
  });

  /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
  /**
   * 
   * @param apiService
   * @param headerService
   * @param router
   * @param changeDetectorRefs
   * @param datePipe
   * @param ContretypageService
   */
  constructor(private apiService: IxellAPIService, private headerService: HeaderService, private router: Router, private changeDetectorRefs: ChangeDetectorRef, private datePipe: DatePipe, private storageService: StorageService, private ContretypageService: ContretypageService) {
    this.colorMatching = new IColorMatchingV1();
    this.colorMatching.colorMatchingID = this.router.getCurrentNavigation().extras.state.colormatchingID;
  }

  /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
  /**
   * Après initialisation de la vue
   */
  ngAfterViewInit() {
    setTimeout(function () {

      //if (this.cloture && !Utils.isAxalta(this.role)) {
      //  console.log("qr code ngAfterViewInit");
      //}

      if (document.getElementsByClassName("select-coatCd").length > 0) {
        var select = document.getElementsByClassName("select-coatCd")[0];
        var child = document.getElementsByClassName("mat-tab-label")[0].children[0] as HTMLElement;
        child.innerText = "";
        child.appendChild(select);
      }

      if (!Utils.isAxalta(this.role) && document.getElementsByClassName("zoomQrCodeContretypage").length > 0) {
        var buttonQrCode = document.getElementsByClassName("zoomQrCodeContretypage")[0];
        child = document.getElementsByClassName("mat-tab-label")[0].children[0] as HTMLElement;
        child.appendChild(document.createTextNode(" - "));
        child.appendChild(buttonQrCode);
      }

    }, 1000);

  }

  /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
  /**
   * initialisation du composant
   */
  ngOnInit() {

    this.copyPasteContretypage = +this.storageService.get("copyPasteContretypage");

    this.varianteList = [];
    //this.varianteList.unshift("contretypage");

    this.stepEdit = 'speaker_notes';

    this.headerService.changeCanBack(true);

    this.roleSub = this.headerService.currentRole.subscribe(
      role => {
        this.role = role;
        if (Utils.isAxalta(this.role)) {
          this.displayedColumns = this.displayedAXALTA;
        }
        else {
          this.displayedColumns = this.displayedOther;
        }
      },
      error => {
        console.log(error);
        if (this.roleSub != null) this.roleSub.unsubscribe();
      }
    );

    this.index = 0;
    this.ingredientToAddArray = new MatTableDataSource<IIngredientColorMatchingV1>();
    this.ingredientArray = new MatTableDataSource<IIngredientColorMatchingV1>();
    this.ingr = [];

    this.textSentenceCMSub = this.apiService.getTextSentence().subscribe(
      data => {
        if (data) {
          this.lstTextSentencesCM = data;
        }

        this.coatCdCMSub = this.apiService.getCoatCd().subscribe(
          data => {
            if (data) {
              this.lstCoatCdCM = data;
              this.responseCMForm.patchValue({
                coatCd: data[0].coatCd
              });
              this.currentCoatCd = data[0].coatCd; //this.lstCoatCdCM[0];
            }

            this.recapExpand = true;
            this.respExpand = false;
            this.colormatchingSub = this.apiService.getColorMatching(this.colorMatching.colorMatchingID).subscribe(
              data => {

                ///*----------------------------------------------*/console.log(data);

                if (this.compareDate(data.dateFinish)) {
                  this.displayedColumns = this.displayedOther;
                }

                this.colorMatching = data;

                let listPaintQuality = this.colorMatching.paintQuality.split(",");

                this.techDemande = "";
                for (let q in listPaintQuality) {
                  this.techDemande += Technologie[+listPaintQuality[q]] + ", "
                }
                if (this.techDemande.length > 1)
                  this.techDemande = this.techDemande.substring(0, this.techDemande.length - 2);

                let firstQuality: number = +this.colorMatching.paintQuality.split(",")[0];
                this.paintQuality = firstQuality;

                this.technologyForm.setValue({
                  technology: firstQuality
                });

                if (data.response != null) {
                  this.paintQuality = data.response.paintQuality;
                  firstQuality = data.response.paintQuality;

                  this.responseCMForm.patchValue({
                    brandVehicle: data.response.brandVehicle,
                    codeFormule: data.response.codeFormule,
                    designationPainting: data.response.designationPainting,
                    variante: data.response.variante,
                    legend: data.response.legend,
                    comment: data.response.comment,
                    formuleInfo: data.response.formuleInfo,
                    sentences: data.response.sentences.split(",").map(Number),
                    coatCd: data.response.coatCd
                  });


                  this.responseCM = new IResponseColorMatchingV1();
                  this.responseCM.brandVehicle = data.response.brandVehicle;
                  this.responseCM.codeFormule = data.response.codeFormule;
                  this.responseCM.designationPainting = data.response.designationPainting;
                  this.responseCM.variante = data.response.variante;
                  this.responseCM.paintQuality = data.response.paintQuality;
                  this.timeFinish = this.datePipe.transform(this.colorMatching.dateFinish, 'HH:mm:ss');

                  this.technologyForm.setValue({
                    technology: data.response.paintQuality
                  });

                  this.textSentencesCM = this.lstTextSentencesCM.filter(element => this.responseCMForm.value.sentences.indexOf(element.id) > -1);

                  if (data.response.multicouches == 1) {
                    for (var i = 0; i < data.response.responseMulti.length; i++) {

                      this.cumul = 0;
                      this.index = 0;
                      let tmp_ingr: IIngredientColorMatchingV1[] = [];
                      let tmp_ingredientArray: IIngredientColorMatchingV1[] = [];
                      //let name = "";
                      let tmp_coatCd = data.response.responseMulti[i].coatCd
                      data.response.responseMulti[i].ingredients.forEach(ingredient => {
                        this.index++;
                        this.cumul += ingredient.quantity;
                        ingredient.qtyCumule = Utils.roundDecimal(this.cumul, 3);
                        tmp_ingr.push(ingredient);
                        tmp_ingredientArray = tmp_ingr;
                      });
                      ///*----------------------------------------------*/console.log(tmp_coatCd);
                      this.listIngrTabs.push(new IngrTab([], tmp_ingredientArray, tmp_ingr, JSON.parse(JSON.stringify(tmp_coatCd))));
                    }
                  }

                  this.cumul = 0;
                  this.index = 0;
                  data.response.ingredients.forEach(ingredient => {
                    this.index++;
                    this.cumul += ingredient.quantity;
                    ingredient.qtyCumule = Utils.roundDecimal(this.cumul, 3);
                    this.ingr.push(ingredient);
                    this.ingredientArray.data = this.ingr;
                  });

                }

                this.ingredientCMSub = this.apiService.getIngredient(Technologie[firstQuality]).subscribe(
                  data => {
                    if (data) {
                      this.AllIngredientArray = data;
                      let mapIngredientArray = this.ingredientArray.data.map(x => x.code);
                      this.ingredientToAddArray.data = this.AllIngredientArray.filter(function (e) { return this.indexOf(e.code) === -1; }, mapIngredientArray);
                      this.listIngrTabs.unshift(new IngrTab(this.ingredientToAddArray.data, this.ingredientArray.data, this.ingr, JSON.parse(JSON.stringify(this.currentCoatCd))));

                      if (Utils.isAxalta(this.role)) {
                        for (var i = 0; i < this.listIngrTabs.length; i++) {
                          this.tabs.push("" + this.listIngrTabs[i].GetCoatCd());
                        }
                      } else {
                        for (var i = 0; i < this.listIngrTabs.length; i++) {
                          this.tabs.push("" + (i + 1));
                        }
                      }

                      for (var i = 1; i < this.listIngrTabs.length; i++) {
                        this.ingr = this.listIngrTabs[i].GetIngr();
                        this.ingredientArray.data = this.listIngrTabs[i].GetIngredientArray();

                        /* ingr et ingredientArray.data sont similaire théoriquement */
                        for (var k = 0; k < this.ingr.length; k++) {
                          var code = this.ingr[k].code;
                          var tmpName = this.AllIngredientArray.find(function (e) { return e.code == code });
                          if (tmpName) {
                            this.ingr[k].name = tmpName.name;
                            this.ingredientArray.data[k].name = tmpName.name;
                          } else {
                            this.ingr[k].name = "unknow";
                            this.ingredientArray.data[k].name = "unknow";

                          }
                        }
                        let mapIngredientArray2 = this.ingredientArray.data.map(x => x.code);
                        this.ingredientToAddArray.data = this.AllIngredientArray.filter(function (e) { return this.indexOf(e.code) === -1; }, mapIngredientArray2);
                        //this.SaveIngrTab(i);
                      }
                      this.GetIngrCurrent(0);

                      this.cloture = this.compareDate(this.colorMatching.dateFinish);
                    }
                  },
                  error => {
                    console.log(error);
                    if (this.ingredientCMSub != null) this.ingredientCMSub.unsubscribe();
                  }
                );

                //setTimeout(function () { }, 3000);

              },
              error => {
                console.log(error);
                if (this.colormatchingSub != null) this.colormatchingSub.unsubscribe();
              }
            );
          },
          error => {
            console.log(error);
            if (this.coatCdCMSub != null) this.coatCdCMSub.unsubscribe();
          }
        );
      },
      error => {
        console.log(error);
        if (this.textSentenceCMSub != null) this.textSentenceCMSub.unsubscribe();
      }
    );
  }

  /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
  /**
   *
   */
  ngOnDestroy() {
    if (this.manufacturerSub != null) this.manufacturerSub.unsubscribe();
    if (this.roleSub != null) this.roleSub.unsubscribe();
    if (this.colormatchingSub != null) this.colormatchingSub.unsubscribe();
    if (this.responseCMSub != null) this.responseCMSub.unsubscribe();
    if (this.ingredientCMSub != null) this.ingredientCMSub.unsubscribe();
    if (this.textSentenceCMSub != null) this.textSentenceCMSub.unsubscribe();
    if (this.formuleSub != null) this.formuleSub.unsubscribe();
    if (this.designationSub != null) this.designationSub.unsubscribe();
    if (this.varianteSub != null) this.varianteSub.unsubscribe();
    if (this.coatCdCMSub != null) this.coatCdCMSub.unsubscribe();
  }

  /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
  /**
   * 
   */
  expandPanel() {
    this.recapExpand = !this.recapExpand;
    this.respExpand = !this.respExpand;
  }

  /**
   * 
   * @param $event
   */
  changeCoatCdSelected($event: any) {
    ///*----------------------------------------------*/console.log("changeCoatCdSelected");

    this.responseCMForm.patchValue({
      coatCd: this.currentCoatCd
    });

    this.listIngrTabs[this.currentTabIndex].SetCoatCd(this.currentCoatCd)
  }

  /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
  /**
   * update la liste des phrase text type sélectionner
   * @param $event
   */
  changeTextFormInfo($event: any) {
    ///*----------------------------------------------*/console.log("changeTextFormInfo");

    this.textSentencesCM = this.lstTextSentencesCM.filter(element => $event.value.indexOf(element.id) > -1);

    let array_textAreaInfo: any = [];
    let string_textAreaInfo = "";
    this.textSentencesCM.forEach(function (e, i) {
      array_textAreaInfo.push(e.text);
    });
    if (array_textAreaInfo.length > 0)
      string_textAreaInfo = array_textAreaInfo.join("\r\n");

    this.responseCMForm.patchValue({
      formuleInfo: string_textAreaInfo,
      sentences: $event.value
    });

    this.changeDetectorRefs.detectChanges();
  }

  /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
  /**
   * 
   * @param date
   */
  compareDate(date: Date) {
    ///*----------------------------------------------*/console.log("compareDate");

    if (date)
      return date.setHours(0, 0, 0, 0) != this.firstDate.setHours(0, 0, 0, 0);
    else
      return false;
  }

  /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
  /**
   * @param $event
   */
  selectManufacturers($event: any) {
    /////*----------------------------------------------*/console.log("selectManufacturers");

    if (this.responseCMForm.value.brandVehicle.length >= 2) {
      this.manufacturerSub = this.apiService.getLstManufacturer(this.responseCMForm.value.brandVehicle).subscribe(data => {
        this.manufacturerList = data;
        if (this.manufacturerSub != null) this.manufacturerSub.unsubscribe();
      },
        error => {
          console.log(error);
        });
    }
  }

  /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
  /**
   *
   * @param $event
   */
  selectCodeFormule($event: any) {
    ///*----------------------------------------------*/console.log("selectCodeFormule");
    if (this.responseCMForm.value.brandVehicle) {
      this.formuleSub = this.apiService.getFormuleContretypage(1, this.paintQuality, this.responseCMForm.value.brandVehicle, this.responseCMForm.value.codeFormule, "").subscribe(data => {
        this.formuleList = data

        if (this.formuleSub != null) this.formuleSub.unsubscribe();
      },
        error => {
          console.log(error)
        });
    }
  }

  /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
  /**
   *
   * @param $event
   */
  selectDesignation($event: any) {
    ///*----------------------------------------------*/console.log("selectDesignation");
    if (this.responseCMForm.value.brandVehicle && this.responseCMForm.value.codeFormule) {
      this.designationSub = this.apiService.getFormuleContretypage(2, this.paintQuality, this.responseCMForm.value.brandVehicle, this.responseCMForm.value.codeFormule, this.responseCMForm.value.designationPainting).subscribe(data => {
        this.designationList = data

        if (this.designationSub != null) this.designationSub.unsubscribe();
      },
        error => {
          console.log(error)
        });
    }
  }

  /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
  /**
   *
   * @param $event
   */
  selectVariantes($event: any) {
    ///*----------------------------------------------*/console.log("selectVariantes");

    this.varianteList = [];

    if (this.responseCMForm.value.brandVehicle && this.responseCMForm.value.codeFormule && this.responseCMForm.value.designationPainting) {
      this.varianteSub = this.apiService.getFormuleContretypage(3, this.paintQuality, this.responseCMForm.value.brandVehicle, this.responseCMForm.value.codeFormule, this.responseCMForm.value.designationPainting).subscribe(data => {
        this.varianteList = data;
        if (this.varianteSub != null) this.varianteSub.unsubscribe();
      },
        error => {
          console.log(error)
        });
    }
  }

  //lauchAlert($event: any) {
  //  console.log($event);
  //}

  /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
  /**
   * 
   * @param $event
   */
  searchCodeFormule($event: any) {
    ///*----------------------------------------------*/console.log("searchCodeFormule");

    let array: IIngredientColorMatchingV1[];
    array = this.AllIngredientArray.filter(element => element.code.startsWith($event.target.value.toUpperCase()));
    this.ingredientToAddArray = new MatTableDataSource(array);
    this.changeDetectorRefs.detectChanges();
  }

  /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
  /**
   * 
   * @param ingredient
   */
  containIngr(ingredient: IIngredientColorMatchingV1) {
    ///*----------------------------------------------*/console.log("containIngr");

    this.ingr.forEach(element => {
      if (ingredient.bnum == element.bnum) {
        return true;
      }
    });
    return false;
  }

  /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
  /**
   * ajoute l'ingrédient a la liste de la réponse
   * supprime l'ingrédient de la liste des selectionnable
   * @param ingredient
   */
  addIngredient(ingredient: IIngredientColorMatchingV1) {
    ///*----------------------------------------------*/console.log("addIngredient");

    this.cumul = 0;
    var doublon = false;
    this.ingr.forEach(element => {
      if (ingredient.bnum == element.bnum)
        doublon = true;
      this.cumul += element.quantity;
    });
    ingredient.qtyCumule = Utils.roundDecimal(this.cumul, 3);
    if (doublon == false) {
      this.index += 1;
      ingredient.position = this.index;
      this.ingr.push(ingredient);
      this.ingredientArray.data = this.ingr;

      let array: IIngredientColorMatchingV1[];
      array = this.ingredientToAddArray.data.filter(element => element.code != ingredient.code);
      this.ingredientToAddArray = new MatTableDataSource(array);
      this.changeDetectorRefs.detectChanges();
    }
  }

  /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
  /**
   * switch deux ingrédient
   * l'ingrédient descend
   * @param ingredient
   */
  downIng(ingredient: IIngredientColorMatchingV1) {
    ///*----------------------------------------------*/console.log("downIng");

    let position = ingredient.position - 1;
    let upDownIngRow = document.getElementsByClassName('upDownIng-row');
    upDownIngRow[position].classList.add("translateDown");
    upDownIngRow[position + 1].classList.add("translateUp");

    setTimeout(this.downIngTimeout.bind(this, [ingredient]), 200);
  }

  /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
  /**
   * fonction timeout downIngr appelé après la transition pour update la liste et le dom
   * */
  downIngTimeout(arg: any) {
    ///*----------------------------------------------*/console.log("downIngTimeout");

    let indexIngrDown = this.ingredientArray.data.map(x => x.code).indexOf(arg[0].code);
    let indexIngrUp = indexIngrDown + 1;
    this.ingr[indexIngrDown].position = indexIngrUp;
    this.ingr[indexIngrUp].position = indexIngrDown;

    this.ingr = this.ingr.sort(this.ingredientSortPosition);

    this.index = 0;
    this.cumul = 0;
    this.ingr.forEach(ingredient => {
      this.index += 1;
      ingredient.position = this.index;
      this.cumul += ingredient.quantity;
      ingredient.qtyCumule = Utils.roundDecimal(this.cumul, 3);
    });
    this.ingredientArray.data = this.ingr;
    document.getElementsByClassName('translateDown')[0].classList.remove("translateDown");
    document.getElementsByClassName('translateUp')[0].classList.remove("translateUp");
  }

  /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
  /**
   * switch deux ingrédient
   * l'ingrédient monte
   * @param ingredient
   */
  upIng(ingredient: IIngredientColorMatchingV1) {
    ///*----------------------------------------------*/console.log("upIng");

    let position = ingredient.position - 1;
    let upDownIngRow = document.getElementsByClassName('upDownIng-row');
    upDownIngRow[position].classList.add("translateUp");
    upDownIngRow[position - 1].classList.add("translateDown");

    setTimeout(this.upIngTimeout.bind(this, [ingredient]), 200);
  }

  /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
  /**
   * fonction timeout upIngr appelé après la transition pour update la liste et le dom
   * */
  upIngTimeout(arg: any) {
    ///*----------------------------------------------*/console.log("upIngTimeout");

    let indexIngrUp = this.ingredientArray.data.map(x => x.code).indexOf(arg[0].code);
    let indexIngrDown = indexIngrUp - 1;
    this.ingr[indexIngrUp].position = indexIngrDown;
    this.ingr[indexIngrDown].position = indexIngrUp;

    this.ingr = this.ingr.sort(this.ingredientSortPosition);

    this.index = 0;
    this.cumul = 0;
    this.ingr.forEach(ingredient => {
      this.index += 1;
      ingredient.position = this.index;
      this.cumul += ingredient.quantity;
      ingredient.qtyCumule = Utils.roundDecimal(this.cumul, 3);
    });
    this.ingredientArray.data = this.ingr;
    document.getElementsByClassName('translateDown')[0].classList.remove("translateDown");
    document.getElementsByClassName('translateUp')[0].classList.remove("translateUp");
  }

  /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
  /**
   * supprime l'ingrédient de la liste réponse
   * ajout l'ingrédient à la liste de séléctionnable
   * @param ingredientDel
   */
  deleteIngredient(ingredientDel: IIngredientColorMatchingV1) {
    ///*----------------------------------------------*/console.log("deleteIngredient");

    this.index = 0;
    this.cumul = 0;
    this.ingr = this.ingr.filter(function (value) { return value.bnum != ingredientDel.bnum });
    this.ingr.forEach(ingredient => {
      this.index += 1;
      ingredient.position = this.index;
      this.cumul += ingredient.quantity;
      ingredient.qtyCumule = Utils.roundDecimal(this.cumul, 3);
    });
    this.ingredientArray.data = this.ingr;

    let array: IIngredientColorMatchingV1[] = [];
    array.push(ingredientDel);
    this.ingredientToAddArray.data = this.ingredientToAddArray.data.concat(array).sort(this.ingredientSortCode);
    this.changeDetectorRefs.detectChanges();
  }

  ///* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
  ///**
  // * fermeture modal ingrédients
  // */
  //closeModalIngredient() {
  //  let modal = document.getElementById("ModalIngredient");
  //  modal.style.display = "none";
  //}

  /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
  /**
   * modifie la quantité d'un ingrédients et modifie les cumul 
   * @param ingr
   */
  changeQty(ingr: IIngredientColorMatchingV1) {
    ///*----------------------------------------------*/console.log("changeQty");

    this.cumul = 0;
    this.ingr.forEach(element => {

      if (ingr.bnum == element.bnum) {
        element.quantity = +(<HTMLInputElement>document.getElementById("qty-" + ingr.bnum)).value;
        this.cumul += element.quantity;
        element.qtyCumule = Utils.roundDecimal(this.cumul, 3);
      }
      else {
        this.cumul += element.quantity;
        element.qtyCumule = Utils.roundDecimal(this.cumul, 3);
      }
    });

    this.ingredientArray.data = this.ingr;
    this.changeDetectorRefs.detectChanges();
  }


  /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
  /**
   * désactive l'action de la touche entrer pour l'event
   * @param event
   */
  preventEnter(event: any) {
    event.preventDefault();
  }

  /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
  /**
   * ouvre une modal d'après l'id passé en paramètre
   * @param idModal
   */
  openModal(idModal: string) {
    ///*----------------------------------------------*/console.log("openModal");
    let modal = document.getElementById(idModal);
    modal.style.display = "block";
    switch (idModal) {
      case "ModalConfirmEnvoi": {
        this.ListIngrTabsValide();
        break;
      }
      case "ModalIngredient": {
        break;
      }
      case "ModalNextMultiCouche": {
        break;
      }
      case "ModalQrCode": {
        this.openZoomQrCodeContretypage();
        break;
      }
      default: {
        break;
      }
    }

  }

  /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
  /**
   * ferme une modal d'après l'id passé en paramètre
   * @param idModal
   */
  closeModal(idModal: string) {
    ///*----------------------------------------------*/console.log("closeModal");
    let modal = document.getElementById(idModal);
    modal.style.display = "none";
    switch (idModal) {
      case "ModalConfirmEnvoi": {
        this.ListIngrTabsValide();
        break;
      }
      case "ModalIngredient": {
        break;
      }
      case "ModalNextMultiCouche": {
        break;
      }
      case "ModalQrCode": {
        break;
      }
      default: {
        break;
      }
    }
  }


  /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
  /**
   * enregistrer et envoi la réponse de axalta
   * reste sur la page et ferme le modal de confirmation en cas d'erreur
   */
  sendResponse() {
    ///*----------------------------------------------*/console.log("sendResponse");

    this.responseCM = new IResponseColorMatchingV1();

    this.idContretypage = this.colorMatching.colorMatchingID;
    this.responseCM = JSON.parse(JSON.stringify(this.responseCMForm.value));
    this.responseCM.paintQuality = JSON.parse(JSON.stringify(this.paintQuality));
    this.responseCM.colorMatchingID = JSON.parse(JSON.stringify(this.colorMatching.colorMatchingID));
    this.responseCM.ingredients = JSON.parse(JSON.stringify(this.listIngrTabs[0].GetIngr()));
    if (this.responseCMForm.value.sentences) {
      this.responseCM.sentences = JSON.parse(JSON.stringify(this.responseCMForm.value.sentences.join(',')));
    }
    this.responseCM.coatCd = JSON.parse(JSON.stringify(this.listIngrTabs[0].GetCoatCd()));
    this.responseCM.responseMulti = [];

    for (var i = 1; i < this.listIngrTabs.length; i++) {
      this.responseMulti = new IResponseColorMatchingV1();
      this.responseMulti = JSON.parse(JSON.stringify(this.responseCM));

      this.responseMulti.responseMulti = [];
      this.responseMulti.paintQuality = JSON.parse(JSON.stringify(this.paintQuality));
      this.responseMulti.colorMatchingID = 0;
      this.responseMulti.coatCd = JSON.parse(JSON.stringify(this.listIngrTabs[i].GetCoatCd()));
      this.responseMulti.ingredients = JSON.parse(JSON.stringify(this.listIngrTabs[i].GetIngr()));
      this.responseCM.responseMulti.push(JSON.parse(JSON.stringify(this.responseMulti)));
    }

    ///*----------------------------------------------*/console.log("sendresponse", this.responseCM);

    //let printHtml = '<html><head><style>@media print {@page {size: A4;margin: 11mm 17mm 17mm 17mm;}}html {  font-size: 16pt;}body {  position: relative;}.infoContretypage, .qrCodeContretypage {  max-width: 50%;  width: 50%;  display: inline-block;  vertical-align: top;}table {  width: 100%;}.infoContretypage div, .infoContretypage p {  padding: 0;  margin: 0;}.toPrint {  display: block;}.headerPrint {  height: 45pt;}.contentPrint {  padding-top: 75pt;} @supports (-moz-appearance:none) {  .contentPrint {    padding-top: 75pt;  }}.enteteImp {  width: 100%;  height: 45pt;  margin-top: 0px;  position: absolute;}.footerImp {  width: 100%;}.imgImp {  position: absolute;  right: 20px;  top: 50px;  width: 15%;}.enteteContent {  position: absolute;  left: 1pt;  color: #FFF;  margin: 0.2em 0;} .accroche {  position: absolute;  font-style: italic;  top: 65px;  width: 75%;}.lstIngrCM {  height: 100%;  display: table;  page-break-inside: auto;  overflow-y: unset;  max-height: none;  padding-top: 20px;}.thumbnail {  max-height: 220px;  max-width: 220px;}.ecartElement {    padding-top: 20px;}    .breakPageAlways {  page-break-before: always;}    thead {  display: table-header-group; width: 100 %; }    tbody {  width: 100%}    tfoot {  display: table-footer-group;  width: 100%}    .lstIngrCM th, .lstIngrCM td {  border-bottom: 1px solid #ddd;  text-align: center;  padding: 2px;}.vertical-align-bottom {    vertical-align: bottom;}</style></head><body>';
    //let headerPrint = '<div class="headerPrint">' + document.getElementsByClassName("headerPrint")[0].innerHTML + '</div>';
    //let reportHtml = '<div class="contentPrint">' + document.getElementsByClassName("contentPrint")[0].innerHTML + '</div>';

    //printHtml += headerPrint + '<table><caption></caption><thead><tr><td> ' + "" + ' </td></tr></thead><tbody><tr><td>' + reportHtml + ' </td></tr></tbody><tfoot><tr><td><div class="headerPrint"> <img class="footerImp" src="assets/bandeau.png" alt=""/></div></td></tr></tfoot></table></body><footer></footer></html>';
    //printHtml = JSON.parse(JSON.stringify(printHtml));
    ///*----------------------------------------------*/console.log(printHtml);

    this.responseCMSub = this.apiService.addResponseColorMatching(this.responseCM, this.storageService.get("CU"), "").subscribe(data => {
      this.router.navigate(['contretypage/historic']);
    }, error => {
      console.log(error);
      this.closeModal("ModalConfirmEnvoi");
    });
  }

  /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
  /**
   * change la technologie de la réponse
   * vide la liste d'ingrédient deja selectionner
   * change la liste d'ingrédient selectionnable
   * */
  changeTechnologySelected() {
    ///*----------------------------------------------*/console.log("changeTechnologySelected");
    var cloture = this.cloture;
    var select: any;

    this.currentTabIndex = 0;

    this.ingredientCMSub = this.apiService.getIngredient(Technologie[this.paintQuality]).subscribe(data => {
      if (data) {
        ///*----------------------------------------------*/console.log(data);
        select = document.getElementsByClassName("select-coatCd")[0];

        this.listIngrTabs = [];
        this.tabs = [];

        this.AllIngredientArray = data;
        this.ingredientToAddArray.data = this.AllIngredientArray;
        this.ingr = [];
        this.ingredientArray.data = this.ingr;
        this.currentCoatCd = this.lstCoatCdCM[0].coatCd;

        var i = 1;

        ///*----------------------------------------------*/console.log("changeTechnologySelected : push in new IngrTab");
        this.listIngrTabs.push(new IngrTab(this.ingredientToAddArray.data, this.ingredientArray.data, this.ingr, this.currentCoatCd));
        this.tabs = [this.lstCoatCdCM[0].coatCd];

        setTimeout(function () {
          if (!cloture) {
            var child = document.getElementsByClassName("mat-tab-label")[0].children[0] as HTMLElement;
            child.innerText = "";
            child.appendChild(select);
          }
        }, 100, select, cloture);

      }
    },
      error => {
        console.log(error);
        if (this.ingredientCMSub != null) this.ingredientCMSub.unsubscribe();
      });
  }

  /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
  /**
   * override edit default icon step
   * @param $event
   */
  changeEditStep($event: any) {
    ///*----------------------------------------------*/console.log("changeEditStep");

    this.SaveIngrTab(this.currentTabIndex);

    switch ($event.selectedIndex) {
      case 0:
        this.stepEdit = 'speaker_notes';
        break;
      case 1:
        this.stepEdit = 'invert_colors';
        break;
      case 2:
        this.stepEdit = 'send';
        break;
      default:
        this.stepEdit = 'speaker_notes';
        break;
    }
  }

  /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
  /**
   * sort les ingrédient d'après leur code ingrédient
   * @param a
   * @param b
   */
  ingredientSortCode(a: any, b: any) {
    const bandA = a.code;
    const bandB = b.code;

    let comparison = 0;
    if (bandA > bandB) {
      comparison = 1;
    } else if (bandA < bandB) {
      comparison = -1;
    }
    return comparison;
  }

  /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
  /**
   * sort les ingrédient d'après leur position
   * @param a
   * @param b
   */
  ingredientSortPosition(a: any, b: any) {
    const bandA = a.position;
    const bandB = b.position;

    let comparison = 0;
    if (bandA > bandB) {
      comparison = 1;
    } else if (bandA < bandB) {
      comparison = -1;
    }
    return comparison;
  }

  /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
  /**
   * impression de la réponse
   */
  print() {
    if (this.colorMatching.response) {
      this.generateQRCode();
      if (this.colorMatching.response.responseMulti) {
        this.generateQRCodeFormuleMulti();
      }
    }

    setTimeout(function () {

      this.win = window.open("", "Title", "toolbar=no,location=no,directories=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=" + (screen.width / 2) + ",height=" + (screen.height / 2) + ",top=" + (100) + ",left=" + (100));

      let printHtml = '<html><head><link rel="stylesheet" href="assets/Impression/ImpressionContretypage.css"></head><body>';
      let headerPrint = '<div class="headerPrint">' + document.getElementsByClassName("headerPrint")[0].innerHTML + '</div>';
      let reportHtml = '<div class="contentPrint">' + document.getElementsByClassName("contentPrint")[0].innerHTML + '</div>';

      printHtml += headerPrint + '<table><caption></caption><thead><tr><td> ' + "" + ' </td></tr></thead><tbody><tr><td>' + reportHtml + ' </td></tr></tbody><tfoot><tr><td><div class="headerPrint"> <img class="footerImp" src="assets/bandeau.png" alt=""/></div></td></tr></tfoot></table></body><footer></footer></html>';
      this.win.document.write(printHtml);
      this.win.document.close();

      setTimeout(function () {
        this.win.print();
        this.win.close();
      }, 900);
    }, 900);
  }

  /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
  /**
   * Génération du QRCode pour l'impression
   */
  generateQRCode() {
    this.infoQRCode = "@LACA@0#";
    this.infoQRCode += this.colorMatching.response.brandVehicle + "#";
    this.infoQRCode += this.colorMatching.response.codeFormule + "#";
    this.infoQRCode += this.colorMatching.response.designationPainting + "#";
    this.infoQRCode += "CONT" + "#";
    this.infoQRCode += this.colorMatching.dateFinish.toLocaleDateString().replace(/\//gi, "") + "#";
    this.infoQRCode += Technologie[this.paintQuality]; //this.techDemande;
    for (let i = 0; i < this.colorMatching.response.ingredients.length; i++) {
      let w: string = this.colorMatching.response.ingredients[i].quantity.toString();
      this.infoQRCode += "#" + this.colorMatching.response.ingredients[i].code + "|" + this.colorMatching.response.ingredients[i].quantity.toFixed(3); //Number.parseFloat(this.colorMatching.response.ingredients[i].quantity.toString().substr(0, w.indexOf(".") + 3)).toFixed(2);
    }
    this.apiService.generateQRCode(this.infoQRCode).subscribe(data => {
      this.qrcode = data;
    });
  }

  /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
  /**
   * Génération du QRCode pour l'impression
   */
  generateQRCodeFormuleMulti() {

    var tmpName = this.AllIngredientArray.find(function (e) { return e.code == code });

    for (var i = 0; i < this.colorMatching.response.responseMulti.length; i++) {
      var infoQRCodeMutli = "@LACA@0#";
      infoQRCodeMutli += this.colorMatching.response.brandVehicle + "#";
      infoQRCodeMutli += this.colorMatching.response.codeFormule + "#";
      infoQRCodeMutli += this.colorMatching.response.designationPainting + "#";
      infoQRCodeMutli += "CONT" + "#";
      infoQRCodeMutli += this.colorMatching.dateFinish.toLocaleDateString().replace(/\//gi, "") + "#";
      infoQRCodeMutli += Technologie[this.paintQuality]; //this.techDemande;
      for (var j = 0; j < this.colorMatching.response.responseMulti[i].ingredients.length; j++) {

        var code = this.colorMatching.response.responseMulti[i].ingredients[j].code;
        var tmpName = this.AllIngredientArray.find(function (e) { return e.code == code });

        if (tmpName) {
          this.colorMatching.response.responseMulti[i].ingredients[j].name = tmpName.name;
        } else {
          this.colorMatching.response.responseMulti[i].ingredients[j].name = "unknow";
        }

        infoQRCodeMutli += "#" + this.colorMatching.response.responseMulti[i].ingredients[j].code
        let w: string = this.colorMatching.response.ingredients[i].quantity.toString();
        infoQRCodeMutli += "|" + this.colorMatching.response.responseMulti[i].ingredients[j].quantity.toFixed(3); //Number.parseFloat(this.colorMatching.response.responseMulti[i].ingredients[j].quantity.toString().substr(0, w.indexOf(".") + 3)).toFixed(2);

      }
      this.apiService.generateQRCodeMulti(infoQRCodeMutli, i).subscribe(data => {
        document.getElementById("qrCodeContretypage-" + data.idFormule).innerHTML = '<div> <img class="thumbnail" src="data:image/png;base64,' + data.qrCode + '" alt=""/> </div>';
      });
    }

  }

  /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
  /**
   *
   */
  openZoomQrCodeContretypage() {
    var ingredients = [];

    this.infoQRCode = "@LACA@0#";
    this.infoQRCode += this.colorMatching.response.brandVehicle + "#";
    this.infoQRCode += this.colorMatching.response.codeFormule + "#";
    this.infoQRCode += this.colorMatching.response.designationPainting + "#";
    this.infoQRCode += "CONT" + "#";
    this.infoQRCode += this.colorMatching.dateFinish.toLocaleDateString().replace(/\//gi, "") + "#";
    this.infoQRCode += Technologie[this.paintQuality]; //this.techDemande;

    if (this.currentTabIndex == 0) {
      ingredients = this.colorMatching.response.ingredients;
    } else {
      ingredients = this.colorMatching.response.responseMulti[this.currentTabIndex - 1].ingredients;
    }
    for (let i = 0; i < ingredients.length; i++) {

      let w: string = ingredients[i].quantity.toString();
      this.infoQRCode += "#" + ingredients[i].code + "|" + ingredients[i].quantity.toFixed(3); //Number.parseFloat(ingredients[i].quantity.toString().substr(0, w.indexOf(".") + 3)).toFixed(2);
    }
    this.apiService.generateQRCode(this.infoQRCode).subscribe(data => {
      this.zoomQrcode = data;
    });



  }

  /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
  /**
   * generation du xml de la formule
   * @param res
   */
  generateXMLFormule(res: IColorMatchingV1) {
    this.ContretypageService.exportContretypage(res);
  }

  /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
  /**
   * 
   * @param res
   */
  copierContretypage(res: IColorMatchingV1) {
    this.storageService.set("copyPasteContretypage", "" + res.colorMatchingID);
  }

  /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
  /**
   * 
   * @param res
   */
  collerContretypage(res: IColorMatchingV1) {
    if (this.storageService.get("copyPasteContretypage")) {
      this.apiService.copieFormuleContretypage(+this.storageService.get("copyPasteContretypage"), res.colorMatchingID).subscribe(data => {
        this.storageService.remove("copyPasteContretypage");
        this.router.routeReuseStrategy.shouldReuseRoute = () => false;
        this.router.onSameUrlNavigation = 'reload';
        this.router.navigate(['contretypage/response'], { state: { colormatchingID: res.colorMatchingID } });
      });
    }
  }

  /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
  /**
   * 
   * @param indexIngrTab
   */
  removeTab(indexIngrTab: number) {
    ///*----------------------------------------------*/console.log("removeTab");

    this.tabs.splice(indexIngrTab, 1);
  }

  /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
  /**
   * passage à la couche suivante (avec création d'une nouvelle couche pour la formule si on est en bouts de liste)
   * @param indexIngrTab
   */
  nextTab(indexIngrTab: number) {
    ///*----------------------------------------------*/console.log("nextTab");
    var cloture = this.cloture;
    var select: Element, oldChild, child;

    this.SaveIngrTab(indexIngrTab);

    if (indexIngrTab + 1 < this.tabs.length) {

      //if (this.cloture && !Utils.isAxalta(this.role)) {
      //  console.log("qr code nextTab");
      //}

      if (!this.cloture) {
        select = document.getElementsByClassName("select-coatCd")[0];
        oldChild = document.getElementsByClassName("mat-tab-label")[indexIngrTab].children[0] as HTMLElement;
        oldChild.innerText = this.listIngrTabs[indexIngrTab].GetCoatCd();
      }

      this.selected.setValue(indexIngrTab + 1);

      this.GetIngrCurrent(indexIngrTab + 1);

      if (!this.cloture) {
        child = document.getElementsByClassName("mat-tab-label")[indexIngrTab + 1].children[0] as HTMLElement;
        child.innerText = "";
        child.appendChild(select);
      }
      this.currentTabIndex = indexIngrTab + 1;
    } else {
      if (Utils.isAxalta(this.role) && this.listIngrTabs[indexIngrTab].TestValidite()) {
        if (!this.cloture) {
          select = document.getElementsByClassName("select-coatCd")[0];
          oldChild = document.getElementsByClassName("mat-tab-label")[indexIngrTab].children[0] as HTMLElement;
          oldChild.innerText = this.listIngrTabs[indexIngrTab].GetCoatCd();
        }

        /* new tab init + reset val selection ingredient + push selection ingrédient dans liste de sauvegarde */
        this.tabs.push('' + (this.tabs.length + 1));
        this.selected.setValue(indexIngrTab + 1);

        this.ingredientToAddArray = new MatTableDataSource<IIngredientColorMatchingV1>();
        this.ingredientToAddArray.data = this.AllIngredientArray;
        this.ingredientArray = new MatTableDataSource<IIngredientColorMatchingV1>();
        this.ingr = [];
        this.currentCoatCd = this.lstCoatCdCM[0].coatCd;

        this.listIngrTabs.push(new IngrTab(this.ingredientToAddArray.data, this.ingredientArray.data, this.ingr, this.currentCoatCd));

        setTimeout(function () {
          if (!cloture) {
            var child = document.getElementsByClassName("mat-tab-label")[indexIngrTab + 1].children[0] as HTMLElement;
            child.innerText = "";
            child.appendChild(select);
          }
        }, 100, select, indexIngrTab, cloture);

        this.currentTabIndex = indexIngrTab + 1;
      }
    }



  }

  //moveSelectNext(indexIngrTab: number) {
  //  setTimeout(function (select, indexIngrTab) {
  //    var child = document.getElementsByClassName("mat-tab-label")[this.currentTabIndex].children[0] as HTMLElement;
  //    child.innerText = "";
  //    child.appendChild(select);
  //  }, 1000, [select, indexIngrTab]);
  //}

  /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
  /**
   * passage à la couche précédente
   * @param indexIngrTab
   */
  previousTab(indexIngrTab: number) {
    ///*----------------------------------------------*/console.log("previousTab");
    var select, oldChild, child;

    if (indexIngrTab - 1 >= 0) {

      //if (this.cloture && !Utils.isAxalta(this.role)) {
      //  console.log("qr code previousTab");
      //}

      if (!this.cloture) {
        select = document.getElementsByClassName("select-coatCd")[0];
        oldChild = document.getElementsByClassName("mat-tab-label")[indexIngrTab].children[0] as HTMLElement;
      }
      this.SaveIngrTab(indexIngrTab);

      if (!this.cloture) {
        oldChild.innerText = this.listIngrTabs[indexIngrTab].GetCoatCd();
      }

      this.selected.setValue(indexIngrTab - 1);
      this.GetIngrCurrent(indexIngrTab - 1);
      this.currentTabIndex = indexIngrTab - 1;

      if (!this.cloture) {
        child = document.getElementsByClassName("mat-tab-label")[indexIngrTab - 1].children[0] as HTMLElement;
        child.innerText = "";
        child.appendChild(select);
      }
    }
  }

  /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
  /**
   * sauvegarde des liste d'ingrédient courant
   * recupération des liste d'ingrédient pour la couche d'après le nouveau index courant
   */
  onTabClick($event: any) {
    ///*----------------------------------------------*/console.log("onTabClick");
    var select, oldChild, child, buttonQrCode;

    if ($event != this.currentTabIndex) {

      if (!this.cloture) {
        ///*----------------------------------------------*/console.log("onTabClick : index !=");
        select = document.getElementsByClassName("select-coatCd")[0];
        oldChild = document.getElementsByClassName("mat-tab-label")[this.currentTabIndex].children[0] as HTMLElement;

        this.SaveIngrTab(this.currentTabIndex);

        oldChild.innerText = this.listIngrTabs[this.currentTabIndex].GetCoatCd();

        this.selected.setValue($event);
        this.GetIngrCurrent($event);
        this.currentTabIndex = $event;

        child = document.getElementsByClassName("mat-tab-label-active")[0].children[0] as HTMLElement;
        child.innerText = "";
        child.appendChild(select);
      } else {
        if (!Utils.isAxalta(this.role)) {
          buttonQrCode = document.getElementsByClassName("zoomQrCodeContretypage")[0];
          oldChild = document.getElementsByClassName("mat-tab-label")[this.currentTabIndex].children[0] as HTMLElement;

          this.SaveIngrTab(this.currentTabIndex);

          oldChild.innerText = this.tabs[this.currentTabIndex]; //("" + (i + 1)); //this.listIngrTabs[this.currentTabIndex].GetCoatCd();

          this.selected.setValue($event);
          this.GetIngrCurrent($event);
          this.currentTabIndex = $event;

          child = document.getElementsByClassName("mat-tab-label-active")[0].children[0] as HTMLElement;
          child.innerText = this.tabs[this.currentTabIndex] + " - ";
          child.appendChild(buttonQrCode);
        } else {
          this.SaveIngrTab(this.currentTabIndex);

          this.selected.setValue($event);
          this.GetIngrCurrent($event);
          this.currentTabIndex = $event;
        }
      }

      ///*----------------------------------------------*/console.log("onTabClick : index !=");

    }

  }


  /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
  /**
   * recupération des liste d'ingrédient pour la couche d'après un index 
   * @param indexIngrTab
   */
  GetIngrCurrent(indexIngrTab: number) {
    ///*----------------------------------------------*/console.log("GetIngrCurrent");

    this.ingredientToAddArray.data = JSON.parse(JSON.stringify(this.listIngrTabs[indexIngrTab].GetIngredientToAddArray()));
    this.ingredientArray.data = JSON.parse(JSON.stringify(this.listIngrTabs[indexIngrTab].GetIngredientArray()));
    this.ingr = JSON.parse(JSON.stringify(this.listIngrTabs[indexIngrTab].GetIngr()));
    this.index = this.ingr.length;
    this.currentCoatCd = JSON.parse(JSON.stringify(this.listIngrTabs[indexIngrTab].GetCoatCd()));
  }

  /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
  /**
   * Sauvegarde des liste d'ingrédients d'après un index
   * @param indexIngrTab
   */
  SaveIngrTab(indexIngrTab: number) {
    ///*----------------------------------------------*/console.log("SaveIngrTab");

    this.listIngrTabs[indexIngrTab].SaveIngrTab(this.ingredientToAddArray.data, this.ingredientArray.data, this.ingr, this.currentCoatCd);
  }

  /**
   * verifie que toute les couche renseigner contienne des ingrédients
   * Renvoi : true / false
   */
  ListIngrTabsValide() {
    ///*----------------------------------------------*/console.log("ListIngrTabsValide");

    for (var i = 0; i < this.listIngrTabs.length; i++) {
      if (!this.listIngrTabs[i].TestValidite()) {
        document.getElementById("modal-content-confirm-strong-multiCouche").style.display = "block";
        return false;
      }
    }
    document.getElementById("modal-content-confirm-strong-multiCouche").style.display = "none";
    return true;
  }


}

export class IngrTab {

  private _ingredientToAddArray: IIngredientColorMatchingV1[]
  private _ingredientArray: IIngredientColorMatchingV1[];
  private _ingr: IIngredientColorMatchingV1[];
  private _coatCd: string;

  constructor(ingredientToAddArray: IIngredientColorMatchingV1[], ingredientArray: IIngredientColorMatchingV1[], ingr: IIngredientColorMatchingV1[], coatCd: string) {
    ///*----------------------------------------------*/console.log("new IngrTab")

    this._ingredientToAddArray = JSON.parse(JSON.stringify(ingredientToAddArray));
    this._ingredientArray = JSON.parse(JSON.stringify(ingredientArray));
    this._ingr = JSON.parse(JSON.stringify(ingr));
    this._coatCd = JSON.parse(JSON.stringify(coatCd));

  }

  /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
  /**
   * renvoi la liste des ingrédient pouvant être ajouter au tableau
   */
  GetIngredientToAddArray() {
    ///*----------------------------------------------*/console.log("GetIngredientToAddArray");

    return JSON.parse(JSON.stringify(this._ingredientToAddArray));
  }

  /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
  /**
   * modifie la liste des ingrédient pouvant être ajouter au tableau
   * @param ingredientToAddArray
   */
  SetIngredientToAddArray(ingredientToAddArray: IIngredientColorMatchingV1[]) {
    ///*----------------------------------------------*/console.log("SetIngredientToAddArray");

    this._ingredientToAddArray = JSON.parse(JSON.stringify(ingredientToAddArray));
  }

  /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
  /**
   * renvoi la liste des ingrédient ajouter au tableau
   */
  GetIngredientArray() {
    ///*----------------------------------------------*/console.log("GetIngredientArray");

    return JSON.parse(JSON.stringify(this._ingredientArray));
  }

  /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
  /**
   * modifie la liste des ingrédient ajouter au tableau
   * @param ingredientArray
   */
  SetIngredientArray(ingredientArray: IIngredientColorMatchingV1[]) {
    ///*----------------------------------------------*/console.log("SetIngredientArray");

    this._ingredientArray = JSON.parse(JSON.stringify(ingredientArray));
  }

  /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
  /**
   * renvoi la liste des ingrédient du tableau
   */
  GetIngr() {
    ///*----------------------------------------------*/console.log("GetIngr");

    return JSON.parse(JSON.stringify(this._ingr));
  }

  /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
  /**
   * modifie la liste des ingrédient du tableau
   * @param ingr
   */
  SetIngr(ingr: IIngredientColorMatchingV1[]) {
    ///*----------------------------------------------*/console.log("SetIngr");

    this._ingr = JSON.parse(JSON.stringify(ingr));
  }

  /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
  /**
  * renvoi le type de couche
  */
  GetCoatCd() {
    ///*----------------------------------------------*/console.log("GetCoatCd");

    return JSON.parse(JSON.stringify(this._coatCd));
  }

  /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
  /**
   * modifie le type de couche
   * @param coatCd
   */
  SetCoatCd(coatCd: string) {
    ///*----------------------------------------------*/console.log("SetCoatCd");

    return this._coatCd = JSON.parse(JSON.stringify(coatCd));
  }

  /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
  /**
   * Verifie que la liste des ingrédient du tableau contient bien des ingrédients
   */
  TestValidite() {
    ///*----------------------------------------------*/console.log("TestValidite");

    if (this._ingr.length > 0) {
      return true;
    }
    return false;
  }

  /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
  /**
   * modifie les 3 liste associé aux ingrédient d'une formule
   * (liste d'ingrédients pouvant être ajouter au tableau, liste des ingrédient ajouter au tableau, liste des ingrédient du tableau)
   * @param ingredientToAddArray
   * @param ingredientArray
   * @param ingr
   */
  SaveIngrTab(ingredientToAddArray: IIngredientColorMatchingV1[], ingredientArray: IIngredientColorMatchingV1[], ingr: IIngredientColorMatchingV1[], coatCd: string) {
    ///*----------------------------------------------*/console.log("SaveIngrTab");

    this._ingredientToAddArray = JSON.parse(JSON.stringify(ingredientToAddArray));
    this._ingredientArray = JSON.parse(JSON.stringify(ingredientArray));
    this._ingr = JSON.parse(JSON.stringify(ingr));
    this._coatCd = JSON.parse(JSON.stringify(coatCd));

  }

}
